import { REACT_APP_NOTIFICATION_URL } from 'config';
import { httpClient } from 'features/auth/utils/http';
import { QueryError, formatErrorMessage } from 'features/shared/model';
import { UseMutationOptions, useMutation } from 'react-query';
import { toast } from 'react-toastify';

const readNotification = async (notificationId: string) => {
  await httpClient.put(`${REACT_APP_NOTIFICATION_URL}/notifications/${notificationId}`);
};

export const useReadNotificationMutation = (
  options?: Omit<
    UseMutationOptions<Awaited<ReturnType<typeof readNotification>>, QueryError, { id: string }, unknown>,
    'mutationFn'
  >
) =>
  useMutation(({ id }) => readNotification(id), {
    ...options,
    onError: (error: QueryError) => {
      const message = formatErrorMessage(error);
      toast.error(message);
      console.error(message);
    }
  });
